import axios from 'axios';

export default {
	getLocale(localeKey) {
		return axios.get(`/api/locale/${localeKey}`);
	},

	getLocales() {
		return axios.get('/api/locale/');
	},
};
